import React, {useEffect, useRef, useState} from 'react';
import TableFunction from "../../../../../components/table/TableFunction";
import {useParams} from "react-router-dom";
import {SEARCH_MODEL} from "../../../../../components/table/Model/TableModel";
import {SimpleSearch} from "../../../../../reduxToolkit/Search/SearchApi";
import {VIEW_TYPE} from "../../../../../enums/ViewType";
import {TABLES} from "../../../../../Apis/Tables";
import {useDispatch, useSelector} from "react-redux";
import DropDownMenuProfile from "../../../../../components/DropDown/DropDownMenuProfile";
import {
    DeleteIconsOptions,
} from "../../../../../components/buttons/IconButtons";
import DropDownMenuItem from "../../../../../components/DropDown/DropDownMenuItem";
import {permissionObj} from "../../../../../Helpers/permission";
import {DeleteItemsApi} from "../../../../../reduxToolkit/Commons/CommonsApi";
import {calculateHeight, errorMsg, isSmWidth} from "../../../../../Apis/functions";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: FullStack
 * @Email: kpozos@ibl.mx
 *
 */
export const ReservationWhiteListApp = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const {permission} = useSelector((state) => state.authenticatioauthennSlice);
    const [searchElement, setSearchElement] = useState('');
    const [selectedList, setSelectedList] = useState([]);
    const [results, setResults] = useState([]);
    const [search, setSearch] = useState(false);
    const [bodyForExport, setBodyForExport] = useState(null);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const option = TABLES.EVENT_ATTENDANCE_LIST_WHITE_LIST;
    const deletePermission = (DEV || permission?.includes(permissionObj?.WEB_EVENT_MANAGE_USERS));
    const [deleteModal, setDeleteModal] = useState(false);
    const [modified, setModified] = useState(false);
    const whiteListRef = useRef(null);

    useEffect(() => {
        if(isSmWidth()) return;
        calculateHeight({elementRef: whiteListRef, bottom:145})

    }, [results]);
    /**
     * Fetches white list data from the server using SimpleSearch API.
     *
     * Builds the request body using pagination, search term, model, and event ID,
     * then updates the results state with the response data.
     *
     * @function getData
     * @returns {void}
     */
    const getData = (page, { searchElement }) => {
        const body = SEARCH_MODEL.setObject({ page, size: rowsPerPage, key: searchElement, model: option, modelId:id });
        dispatch(SimpleSearch({ body })).then(
            ({
                 payload: {
                     data: { data },
                 },
             }) => {
                setResults(data);
            },
        );
    };

    const getActionsButtons = (item, index) => {
        if(!deletePermission) return '';

        return (
            <DropDownMenuProfile
                openMenu={openMenu}
                handleMenuToggle={handleMenuToggle}
                menuId={`menu-${item.id}`} // Unique menu ID for each contractor
            >
                <DropDownMenuItem
                    id={'btn_rwla_delete_' + item?.id}
                    index={index}
                    handleClose={handleClose}
                    name={t('delete')}
                    fontColor={'font-color-error-600'}
                    iconColor={"icon-color-error-code-600"}
                    click={() => {
                        setSelectedList([item?.id]); // Set selected item ID for deletion
                        setDeleteModal(true);
                    }}
                    icon={<DeleteIconsOptions />}
                />
            </DropDownMenuProfile>
        );
    };

    const handleDelete = () => {
        dispatch(DeleteItemsApi({ tableName: TABLES.EVENT_ATTENDANCE_LIST, body: selectedList })).then(
            ({
                 payload: {
                     data: { success, code },
                 },
             }) => {
                if (success === true) {
                    setModified(true);
                } else errorMsg(code);
                setSelectedList([]);
            },
        );
    };

    const {
        t,
        pagination,
        rowsPerPage,
        openMenu,
        handleMenuToggle,
        handleClose
    } = TableFunction({
        data: results,
        view:VIEW_TYPE.GRID.name,
        labelRowsPerPage:'logs_per_page',
        fixedPagination: false, // Disable fixed pagination
        hasContainer: true, // Enable container for the table
        searchElement, //New
        getData,//New
        modified
    });

    return {
        t,
        searchElement,
        setSearchElement,
        results,
        setResults,
        option,
        rowsPerPage,
        setBodyForExport,
        setSimpleSearch,
        setSearch,
        selectedList,
        setSelectedList,
        pagination,
        getData,
        deleteModal,
        setDeleteModal,
        getActionsButtons,
        handleDelete,
        whiteListRef
    };
};
